import Vue from 'vue'
import VueI18n from 'vue-i18n';
import country_langs from '../../../../../public/js/lang/country_langs.json'
import es from '../../../../../public/js/lang/es.json'


class CustomVueI18n extends VueI18n {
    constructor(props) {
        super(props);
    }
    _te(key, locale, messages, ...args) {
        const chain = this._getLocaleChain(locale, this.fallbackLocale);
        return chain.some((lang) => super._te(key, lang, messages, ...args));
    }
    get locale () { return this._vm.locale }
    set locale (locale) {
        this.setLocale(locale);
    }
    async setLocale(locale){
        if (locale === undefined) {
            return;
        }
        await this.loadLocale(locale);
        this._vm.$set(this._vm, 'locale', locale);
    }
    async loadLocale(locale) {
        const langs = this.fallbackLocale[locale];
        for (let langIdx in langs) {
            let lang = langs[langIdx];
            console.log("I18N checking lang:"+lang);
            if (Object.keys(this.getLocaleMessage(lang)).length == 0) {
                console.log("I18N loading lang:"+lang);
                try {
                    const res = await import(`../../../../../public/js/lang/${lang}.json`)
                    this.setLocaleMessage(lang, res.default)
                }
                catch(e) {
                    if (e instanceof Error && e.code === "MODULE_NOT_FOUND") {
                        console.log("I18N NOT FOUND lang: " + lang);
                    } else {
                        console.log("I18N FAIL loading lang: " + lang);
                        console.log(e)
                    }
                }
            }
        }
    }
    transFromMap(map, key, locale) {
        let mapKey = `maps.${map}.${key}`;
        let trans = this.t(mapKey, locale);
        if (trans == mapKey) {
            let lastPart = key.split('##').at(-1);
            lastPart = lastPart.replace('_',' ');
            trans = lastPart.charAt(0).toUpperCase() + lastPart.slice(1);
        }
        return trans;
    }

}

Vue.use(CustomVueI18n)
Vue.prototype.$tmap = function(map, key, locale) {
    let i18n = this.$i18n;
    return i18n.transFromMap.apply(i18n, [map, key, locale]);
}
// building decision fallback translation
const getFallbackLocale = () => {
    const langFallback = 'es';
    let fallbackLocale = {};
    let aira_langs = window.AIRA_LANGS ? window.AIRA_LANGS : "es";
    aira_langs = aira_langs.split(',');
    const country_codes = country_langs;
    aira_langs.forEach(lang =>  {
        if (lang !== langFallback) {
            fallbackLocale[`${lang}`] = [lang, langFallback];
        }
        let countries = Object.values(country_codes); 
        for (let index = 0; index < countries.length; index++) {
            let fallbacks = [`${lang}_${countries[index]}`, lang];
            if (lang !== langFallback) {
                fallbacks.push(`${langFallback}_${countries[index]}`);
            }
            fallbackLocale[`${lang}_${countries[index]}`] = fallbacks;
        }
    })
    fallbackLocale['default'] = [ window.LANG_LOCALE ? window.LANG_LOCALE : langFallback, langFallback ];
    return fallbackLocale;
}

const i18n = new CustomVueI18n({
    locale: window.LANG_LOCALE ? window.LANG_LOCALE : "es",
    fallbackLocale: getFallbackLocale(),
    messages: {es},
    silentTranslationWarn: true
});
i18n.locale = window.LANG_LOCALE ? window.LANG_LOCALE : "es";

export {
    i18n
}